import { render, staticRenderFns } from "./ClinicRegisterAndEditDialog.vue?vue&type=template&id=3743be2c&scoped=true"
import script from "./ClinicRegisterAndEditDialog.vue?vue&type=script&lang=js"
export * from "./ClinicRegisterAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicRegisterAndEditDialog.vue?vue&type=style&index=0&id=3743be2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743be2c",
  null
  
)

export default component.exports